import { useMemo } from 'react'
import { syncraApi, syncraApiAdapter } from '@/api/main/syncraClient'
import type { ApiError, TraderWithdrawProfile, TraderWithdrawsReferralListParamsStatusEnum } from 'syncra-api-client'
import { DEFAULT_TAKE } from '@/shared/constants/constants'

type UseReferralWithdrawsParams = {
  referralId: string
  status?: TraderWithdrawsReferralListParamsStatusEnum
  skip?: number
  take?: number
}

type UseReferralWithdrawsResult = {
  data: {
    items: TraderWithdrawProfile[] | null
    count: number
    effectiveSkip: number
  }
  loading: boolean
  error: ApiError | null
}

export function useReferralWithdraws(params: UseReferralWithdrawsParams): UseReferralWithdrawsResult {
  const effectiveSkip = params.skip ?? 0
  const take = params.take ?? DEFAULT_TAKE

  const query = useMemo(() => {
    return {
      referralId: params.referralId,
      status: params.status,
      skip: effectiveSkip,
      take,
    }
  }, [params.referralId, params.status, effectiveSkip, take])

  const queryKey = useMemo(() => [
    'referral-withdraws',
    params.referralId,
    params.status,
    effectiveSkip,
    take,
  ], [params.referralId, params.status, effectiveSkip, take])

  const { data: rawData, isLoading: loading, error } = syncraApiAdapter.createQueryHook<any>(
    queryKey,
    () => syncraApi.v1.traderWithdrawsReferralList(query)
  )()

  const items = useMemo(() => {
    const extracted = rawData?.items ?? null
    return extracted
  }, [rawData])

  const count = useMemo(() => rawData?.count ?? 0, [rawData])

  return {
    data: {
      items,
      count,
      effectiveSkip,
    },
    loading,
    error: error as ApiError | null,
  }
}


